
















































































import {
    Component, Mixins, Model, Watch,
} from 'vue-property-decorator';
import moment, { months } from 'moment';
import CustomDialog from '@/components/global/CustomDialog.vue';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';

@Component({
    components: {
        CustomDialog,
    },
})
export default class VerifyEmailDialog extends Mixins(IsMobileMixin) {
    @Model('update:returnValue', { type: Boolean }) readonly value!: boolean;

    public timeDuration = 0;

    public minute = 0;

    public second = 0;

    public btnDisable = true;

    public btnLabel = 'Resend email';

    public lastResendVerifyEmail = 0;

    public emitReturnValue(event: any) {
        this.$emit('update:returnValue', event);
    }

    public onResendEmail() {}

    public updateLastResendEmailVerification() {}

    public setLastResendEmailVerification() {}

    public async initCoundown() {
        this.btnDisable = true;
        this.btnLabel = 'Please wait to resend again';
        const now = moment.unix(moment().unix()).utc().unix();
        const interval = this.lastResendVerifyEmail - now;
        if (interval > 0) {
            let duration = moment.duration(interval, 'seconds');
            const countdown = setInterval(() => {
                if (duration.asSeconds() <= 1) {
                    clearInterval(countdown);
                    this.btnDisable = false;
                    this.btnLabel = 'Resend email';
                }
                duration = moment.duration(duration.asSeconds() - 1, 'seconds');
                this.minute = duration.minutes();
                this.second = duration.seconds();
            }, 1000);
        } else {
            this.btnDisable = false;
        }
    }

    @Watch('value', { immediate: true })
    private async onValueChanged(val: boolean, oldVal: boolean) {
        if (val) {
            await this.updateLastResendEmailVerification();
            this.initCoundown();
        }
    }
}
